import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { ROUTES } from '@/routes/Routes';

type Args = {
  value?: boolean;
};

export default function useRedirectHomeIfValueIsTrue({ value }: Args) {
  const navigate = useNavigate();

  useEffect(() => {
    if (value) {
      navigate(ROUTES.HOME);
    }
  }, [value, navigate]);
}
